export const comments_4180330 = {"data":{"data":[],"links":{}}}